import { jsx as _jsx } from "react/jsx-runtime";
import { CarouselAd } from "@/ads/components/CarouselAd/CarouselAd";
import { Box } from "@gemini/core";
export const LastImagePlaceholder = ({ testId }) => (_jsx(Box, { as: "div", display: "flex", alignItems: "center", justifyContent: "center", testId: `${testId}.Image.LastImagePlaceholder`, id: "last-image-placeholder", children: _jsx(CarouselAd, {}) }));
